import { useTranslation } from 'react-i18next';

import { useUser } from 'store'

import HeaderBar from '../components/HeaderBar'
import { MENU_DASHBOARD } from '../../Sidebar'

const Home = () => {
  const { t } = useTranslation()
  const [user] = useUser()
  return (
    <HeaderBar
      title={t(MENU_DASHBOARD.label)}
      subtitle={user ? t('header.welcome', { firstName: user.first_name, lastName: user.last_name }) : undefined}
    />
  )
}

export default Home